import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2 space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/WLUMAPS1.png"
                alt="WLUMAPS Logo"
                className="w-8 h-8"
              />
              <span className="text-xl font-bold text-white tracking-tight">
                WLU<span className="text-purple-400">MAPS</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              Simplifying campus life for Wilfrid Laurier University students. 
              Find study spots, check classroom availability, and navigate campus with ease.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold text-white uppercase tracking-wider">Platform</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/search-page" className="text-gray-400 hover:text-white transition-colors text-sm">Find Study Spots</Link>
              </li>
              <li>
                <Link to="/availability" className="text-gray-400 hover:text-white transition-colors text-sm">Empty Classrooms</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">About Us</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold text-white uppercase tracking-wider">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/report" className="text-gray-400 hover:text-white transition-colors text-sm">Report a Bug</Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors text-sm">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors text-sm">Terms of Service</Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} WLUMAPS. Built by students, for students.
          </p>
          <div className="flex items-center gap-6">
            <a 
              href="https://instagram.com/wlumaps" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-white transition-colors"
            >
              Instagram
            </a>
            <a 
              href="https://linkedin.com/company/wlumap" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-white transition-colors"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}